export default __webpack_public_path__ + "static/media/claim_light.f881a87b.png";